import { Component, inject, Input, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ApiService } from "src/app/api.service";
import { DvsUtilities, RECENT_OPERATIONS_LIMIT } from "src/app/dvs-utilities";
import { DatetimePipe, RuntimePipe } from "src/app/pipes";
import { APIResults } from "src/app/sharedinterfaces";
import { DvsChartComponent } from "src/app/shared/dvs-chart/dvs-chart.component";
import { ChartingService } from "src/app/charting.service";

@Component({
	selector: "app-abs-check",
	imports: [FormsModule, DatetimePipe, RuntimePipe, DvsChartComponent],
	templateUrl: "./abs-check.component.html",
	styleUrl: "./abs-check.component.scss",
})
export class AbsCheckComponent implements OnInit {
	api = inject(ApiService);
	charting = inject(ChartingService);

	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	vibecheck: APIResults.VibeCheck;

	public GetOpClass = DvsUtilities.GetOpClass;
	public operations: APIResults.Operation[];
	public multiOps = false;
	public operation?: APIResults.Operation;
	public multiOperation?: APIResults.Operation[];
	public boxPlotOptions: Highcharts.Options;
	public plotError: string;

	ngOnInit() {
		this.refreshOperations();
	}

	async refreshOperations() {
		this.operations = undefined;
		const operations = await this.api.GetOperations(this.asset.asset_id, RECENT_OPERATIONS_LIMIT);
		this.operations = operations;
		if (this.operations.length > 0) {
			let selectedOp: APIResults.Operation;
			selectedOp = this.operations.find(item => item.rotor_turn_time > 300);
			if (!selectedOp) {
				selectedOp = this.operations[0];
			}
			this.operation = selectedOp;
			this.multiOperation = [selectedOp];
			await this.refreshCheck();
		}
	}

	async refreshCheck() {
		this.plotError = undefined;
		this.boxPlotOptions = undefined;
		if (this.multiOperation && this.multiOperation.length > 5) {
			this.multiOperation = this.multiOperation.slice(0, 5);
		}
		const ops = this.multiOps ? this.multiOperation : [this.operation];
		if (ops && ops.length > 0) {
			try {
				const opIds = ops.map(item => item.operation_id);
				const check = await this.api.GetAbsCheck(this.asset.asset_id, opIds);
				this.boxPlotOptions = this.charting.BoxPlotDefaults("CIs", check.map(item => item.name), check.map(item => item.box), check.map(item => item.outliers), "IPS");
			} catch {
				this.plotError = "No data available for the selected operations";
			}
		}
	}
}